module.exports = __webpack_public_path__ + "static/img/logo.7590aeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/logo.svg
// module id = NABr
// module chunks = 13